export default __webpack_public_path__ + "static/media/account_02.8eb491cc.png";